module.exports = __webpack_public_path__ + "img/0-101.1664957c.jpg";